export default "__VITE_ASSET__BZuzgOxh__"